import { pagesMap } from '../Pages/pagesBooks/pagesBook';
import { RouterPagesStore } from '../stores/routerPages';
import { AppSystem, IComponentName, IPage, IRouterState } from '../interfaces';

export function setRouterStoreUseExternalUrlManager(value: boolean): void {
    const RouterPagesStoreInstance = RouterPagesStore.getInstance();
    RouterPagesStoreInstance.setUseExternalUrlManager(value);
}

export function setRouterStoreUseExternalPageTitleManager(value: boolean): void {
    const RouterPagesStoreInstance = RouterPagesStore.getInstance();
    RouterPagesStoreInstance.setUseExternalPageTitleManager(value);
}

export function getRouterStoreCurrentComponent(): IRouterState {
    const RouterPagesStoreInstance = RouterPagesStore.getInstance();
    return RouterPagesStoreInstance.currentComponent;
}

export function setRouterStoreCurrentComponent(component: IRouterState): void {
    const RouterPagesStoreInstance = RouterPagesStore.getInstance();
    RouterPagesStoreInstance.setCurrentComponent(component);
}

export function getRouterStoreRequestedPage(): IRouterState {
    const RouterPagesStoreInstance = RouterPagesStore.getInstance();
    return RouterPagesStoreInstance.requestedPage;
}

export function setRouterStoreRequestedPage(page: IRouterState): void {
    const { routeName, params, queryParams } = page;
    const RouterPagesStoreInstance = RouterPagesStore.getInstance();
    return RouterPagesStoreInstance.setRequestedPage({
        routeName,
        params,
        queryParams: queryParams,
    });
}

export function setRouterStoreRequestedUrl(url: string): void {
    const RouterPagesStoreInstance = RouterPagesStore.getInstance();
    return RouterPagesStoreInstance.setRequestedUrl(url);
}

export function isAvailablePage(page: IComponentName): boolean {
    const RouterPagesStoreInstance = RouterPagesStore.getInstance();
    return !!RouterPagesStoreInstance.availablePages.find((p: IPage) => p.componentName === page);
}

// ------------ AppSystem ------------
export function setAppSystem(appSystem: AppSystem): void {
    const RouterPagesStoreInstance = RouterPagesStore.getInstance();
    RouterPagesStoreInstance.setAppSystem(appSystem);
}
export function setAppSystemBySwitch(appSystem: AppSystem): void {
    setRouterStoreUseExternalUrlManager(false);
    const storeCurrentComponent = getRouterStoreRequestedPage();
    setAppSystem(appSystem);
    setRouterStoreCurrentComponent(storeCurrentComponent);
}
export function setAppSystemByCurrentComponent(component: IRouterState): void {
    const findPage = pagesMap.find((p: IPage) => p.componentName === component.routeName);

    if (findPage?.url === '#') {
        return;
    }

    if (findPage?.appSystem) {
        setAppSystem(findPage?.appSystem);
    }
}
